module.exports = __webpack_public_path__ + "static/media/crowdplat-icons.6430c61f.png";